var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgShoppingBagIcon = function SvgShoppingBagIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.667 6V4a2.667 2.667 0 0 0-5.334 0v2m-2.938.901-.4 4.267c-.114 1.213-.171 1.82.03 2.288a2 2 0 0 0 .88.966c.448.245 1.057.245 2.276.245h5.638c1.219 0 1.828 0 2.276-.245.393-.214.703-.554.88-.966.2-.468.144-1.075.03-2.288l-.4-4.267c-.096-1.024-.144-1.536-.374-1.924a2 2 0 0 0-.861-.784C11.963 4 11.448 4 10.42 4H5.58c-1.028 0-1.543 0-1.95.193a2 2 0 0 0-.861.784c-.23.388-.278.9-.374 1.924Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "currentColor"
  })));
};

export default SvgShoppingBagIcon;